import {
  CompositeTableColumns,
  CurrentYearTableColumns,
  TotalReturnsRowNames,
} from './total-returns-table.model';

import { Constants as TotalReturnsConstants } from '../total-returns/total-returns.constants';

export const Constants = {
  TAG_NAME: 'pop-total-returns-table-component',
  NO_VALUE_DISPLAY: 'no-value-display',
  MONTHLY_YTD_ID: 'monthly-ytd',
  ONE_MONTH_ID: 'one-month',
  THREE_MONTHS_ID: 'three-months',
  ONE_YEAR_ID: 'one-year',
  THREE_YEAR_ID: 'three-year',
  FIVE_YEAR_ID: 'five-year',
  TEN_YEAR_ID: 'ten-year',
  SINCE_INCEPTION_ID: 'since-inception',
  PERCENT: 'percent',
  EN_US: 'en-US',
} as const;

export const CompositePerformanceColumnIds: CompositeTableColumns = {
  OneYear: Constants.ONE_YEAR_ID,
  ThreeYear: Constants.THREE_YEAR_ID,
  FiveYear: Constants.FIVE_YEAR_ID,
  TenYear: Constants.TEN_YEAR_ID,
  SinceInception: Constants.SINCE_INCEPTION_ID,
} as const;

export const CompositePerformanceColumnHeaders: CompositeTableColumns = {
  OneYear: TotalReturnsConstants.ONE_YEAR,
  ThreeYear: TotalReturnsConstants.THREE_YEAR,
  FiveYear: TotalReturnsConstants.FIVE_YEAR,
  TenYear: TotalReturnsConstants.TEN_YEAR,
  SinceInception: TotalReturnsConstants.SINCE_INCEPTION,
} as const;

export const RowHeaders: TotalReturnsRowNames = {
  PureGross: TotalReturnsConstants.PURE_GROSS,
  PureGrossFixedIncome: TotalReturnsConstants.PURE_GROSS_FIXED_INCOME,
  Net: TotalReturnsConstants.NET,
  NetFixedIncome: TotalReturnsConstants.NET_FIXED_INCOME,
  Benchmark: TotalReturnsConstants.BENCHMARK,
  ValuePureGross: TotalReturnsConstants.VALUE_PURE_GROSS,
  ValueNet: TotalReturnsConstants.VALUE_NET,
} as const;

export const CurrentYearPerformanceColumnIds: CurrentYearTableColumns = {
  MonthlyYTD: Constants.MONTHLY_YTD_ID,
  OneMonth: Constants.ONE_MONTH_ID,
  ThreeMonths: Constants.THREE_MONTHS_ID,
} as const;

export const CurrentYearPerformanceColumnHeaders: CurrentYearTableColumns = {
  MonthlyYTD: TotalReturnsConstants.MONTHLY_YTD,
  OneMonth: TotalReturnsConstants.ONE_MONTH,
  ThreeMonths: TotalReturnsConstants.THREE_MONTHS,
} as const;
